<template>
    <div class="p-4 lg:w-full md:w-full">
        <div class="space-y-4">
            <div class="field w-full mb-4 flex items-center">
                <JetLabel
                    class="w-1/3 my-2 text-lg font-bold"
                    for="total_hps"
                    value="Verifikasi HPS"
                />
            </div>
            <div v-if="approval_hps.length > 0" class="w-full mt-6">
                <table class="table-auto w-full border-collapse border border-gray-200">
                    <thead>
                        <tr class="bg-gray-100">
                            <th class="border border-gray-200 p-2">No</th>
                            <th class="border border-gray-200 p-2">Nama Barang / Jasa</th>
                            <th class="border border-gray-200 p-2">Tipe</th>
                            <th class="border border-gray-200 p-2">Merk</th>
                            <th class="border border-gray-200 p-2">Spesifikasi</th>
                            <th class="border border-gray-200 p-2">Volume</th>
                            <th class="border border-gray-200 p-2 text-right">Harga Satuan</th>
                            <th class="border border-gray-200 p-2">Satuan</th>
                            <th class="border border-gray-200 p-2 text-right">Jumlah Harga</th>
                            <th class="border border-gray-200 p-2">Catatan</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(detail, index) in approval_hps" :key="index">
                            <td class="border border-gray-200 p-2">{{ detail.urutan }}</td>
                            <td class="border border-gray-200 p-2">{{ detail.nama_barang_jasa }}</td>
                            <td class="border border-gray-200 p-2">{{ detail.tipe }}</td>
                            <td class="border border-gray-200 p-2">{{ detail.merk }}</td>
                            <td class="border border-gray-200 p-2" style="max-width:180px;word-break:break-word;white-space:pre-line;">
                                <span v-if="detail.spesifikasi && detail.spesifikasi.length > 40" :title="detail.spesifikasi">
                                    {{ detail.spesifikasi.substring(0, 40) + '...' }}
                                </span>
                                <span v-else>{{ detail.spesifikasi }}</span>
                            </td>
                            <td class="border border-gray-200 p-2">{{ detail.volume }}</td>
                            <td class="border border-gray-200 p-2 text-right">{{ formatCurrency(detail.harga_satuan) }}</td>
                            <td class="border border-gray-200 p-2">{{ detail.satuan }}</td>
                            <td class="border border-gray-200 p-2 text-right">{{ formatCurrency(detail.harga_satuan * detail.volume) }}</td>
                            <td class="border border-gray-200 p-2">
                                <input 
                                    v-model="detail.catatan" 
                                    class="w-full p-2 border border-gray-300 rounded-md" 
                                    type="text"
                                    @input="$emit('update:approval_hps', approval_hps)"
                                >
                            </td>
                        </tr>
                        <tr class="bg-gray-100 font-bold">
                            <td colspan="8" class="border border-gray-200 p-2 text-right">Total Jumlah Harga</td>
                            <td colspan="1" class="border border-gray-200 p-2 text-right">{{ formatCurrency(totalJumlahHarga) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import readXlsxFile from "read-excel-file";

import { defineComponent } from 'vue'
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import Button from 'primevue/button';
import JetLabel from "@/Jetstream/Label";

export default defineComponent({
    components: {
        Fieldset,
        Button,
        FileUpload,
        JetLabel
    },
    props: {
        approval_hps: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            selectedFileName: '',
            kategoriHpsData: [],
            localDetailHps: [],
            // totalJumlahHarga: 0
        };
    },
    watch: {

    },
    methods: {
        formatCurrency(value) {
            return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(value);
        }
    },
    computed: {
        totalJumlahHarga() {
            return this.approval_hps.reduce((acc, curr) => acc + (curr.harga_satuan * curr.volume), 0);
        }
    },
    mounted() {
        // this.localDetailHps = [...this.approval_hps];
    }
});
</script>
